import { Route } from "react-router-dom";
import { PaymentsOverview } from "./PaymentsOverview";

export const getPaymentsOverviewScene = () => (
  <Route path="payments-overview">
    <Route path="*" element={<PaymentsOverview />} />
  </Route>
);
